export enum SearchProvider {
    Allianz = 'allianz',
    Atradius = 'atradius',
    CreditSafe = 'credit-safe',
}
